import {
  FinancialSetupModel
} from "@app/pages/quote/standard-quote/catalogs/financial-setup/new-financial-setup/components/model-template/financial-setup.model";

export interface StandardFinancialSetupAttribute {
  id: number | null;
  type: string;
  value: string;
  partial?: boolean | null;
}

export type ModelFilter = {
  modelType: string,
  partial: boolean | null,
  values: number[]
}

export class FinancialSetupCreationDto {
  status: string;
  id: number;
  activeEndDate?: Date;
  active: boolean;
  activeStartDate?: Date;
  /** Días de vigencia de las cotizaciones generadas con este paquete (desde fecha de creación). */
  quoteValidityDays?: number;
  financialSetupName?: string;
  modelType: string;
  personaType: string;
  financialProduct: string;
  currency: string;
  classification: boolean;
  calendarType: string;
  paymentFormationType: string;
  allowPaymentDay: boolean;
  allowCapitalGrace: boolean;
  allowInterestGrace: boolean;
  allowOpeningFee: boolean;
  companyName: string;
  financialSetupDescription: string;
  paymentType?: string;
  downPaymentTaxType: string;
  standardFinancialSetupAttributes: StandardFinancialSetupAttribute[];
  insurancesType: string;
  warrantyDeposit: string;
  warrantyType: string;
  openingFeeType: string;
  additionalCollateral: string;
  subsidyType: string;
  subsidyValue: number;
  balloonType: string;
  balloonPercentage: number;
  residualValueType: string;
  purchaseOptionType: string;
  residualValueTotal: number;
  financialConditions: FinancialCondition[];
  financialSetupHistories: FinancialSetupHistories[];
  version : string;
  versions: FinancialSetupVersion[];
  financialSetupModels: FinancialSetupModel[];
  financialSetupModelsFilter: ModelFilter[];
  dealerIds: number[];
  taxFree?: boolean;
  /** Paquete programa Loyalty (cotización estándar). */
  loyaltyFinancialPackage?: boolean;
  /** Paquete Feria (cotización estándar). */
  feriaFinancialPackage?: boolean;
}
export interface FinancialCondition {
  id: number | null;
  allowPaymentDay: boolean;
  minDownPaymentPercentage: number;
  maxDownPaymentPercentage: number;
  nominalRate: number;
  insuranceNominalRate: number;
  openingFeePercentage: number;
  purchasePercentage: number;
  paymentIncentive: number;
  warrantyDepositPercentage: number;
  gracePeriod: number;
  gracePeriodInterest: number;
  term: number;
  active: boolean;
}

export interface FinancialSetupHistories {
  id: number | null;
  creationDate:Date;
  updatedDate:Date;
  creationUser: number;
  updateUser: number;
  action: string;
  comments: string;
  userName: string;
}

export interface FinancialSetupVersion {
  version: number;
  financialSetupId: number;
}

